export default __webpack_public_path__ + "static/media/young-female-entrepreneur-working-in-a-home-office-58215150.5410e4b9.png";